module.exports = __webpack_public_path__ + "img/14.0bc1578a.jpg";